import Vue from "vue";
import VueI18n from "vue-i18n";
import en from "@/locales/en";
import ar from "@/locales/ar";
import financeReports2, { withFinanceReports2 } from "@/locales/finance-reports";

Vue.use(VueI18n);

export const SUPPORTED_LOCALES = ["en", "ar"];
export const DEFAULT_LOCALE = "en";

export function normalizeLocale(locale) {
  return SUPPORTED_LOCALES.includes(locale) ? locale : DEFAULT_LOCALE;
}

export function getStoredLocale() {
  return normalizeLocale(localStorage.getItem("selectedLanguage"));
}

export function applyLocaleSettings(locale, vuetify) {
  const normalizedLocale = normalizeLocale(locale);
  const isArabic = normalizedLocale === "ar";

  document.documentElement.setAttribute("lang", normalizedLocale);
  document.documentElement.setAttribute("dir", isArabic ? "rtl" : "ltr");
  document.body.classList.toggle("app-lang-ar", isArabic);
  document.body.classList.toggle("app-lang-en", !isArabic);

  if (vuetify) {
    vuetify.rtl = isArabic;
    if (vuetify.lang) {
      // Keeps Vuetify's own strings (data-table footer etc.) localized.
      vuetify.lang.current = normalizedLocale;
    }
  }
}

const i18n = new VueI18n({
  locale: getStoredLocale(),
  fallbackLocale: DEFAULT_LOCALE,
  silentFallbackWarn: true,
  // The 2026-10-03 ledger reports keep per-report locale files, merged here
  // once under finance.reports2 (see src/locales/finance-reports/index.js).
  messages: {
    en: withFinanceReports2(en, financeReports2.en),
    ar: withFinanceReports2(ar, financeReports2.ar),
  },
});

export default i18n;